module.exports = __webpack_public_path__ + "img/5.c8b16152.png";